import { classNamePrefix as prefixCt } from "@/utils/common";
import "../index.less";

function handleClick(e) {
  const $target = e.target;
  if (!$target.closest(`.${prefixCt("collapse-title")}`)) return;
  const $collapse = $target.closest(`.${prefixCt("collapse")}`);
  const cls = $collapse.classList;
  if (cls.contains("active")) {
    cls.remove("active");
  } else {
    cls.add("active");
  }

  e.stopPropagation();
  e.preventDefault();
}

export default class collapseRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("collapse")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    node.addEventListener("click", handleClick, false);
  };
}
